import { LoadModuleOnConditionTrigger } from "@allaihealth/angular-survey";
import { Subject } from "rxjs";

/** Runtime versions of the load module trigger */
export class RuntimeLoadModuleTrigger extends LoadModuleOnConditionTrigger {
	/** Has the trigger been triggered yet? This prevents the trigger from triggering multiple times */
	private _isTriggered:boolean = false;

	/** Create instance with the subject to call when loading and unloading modules */
	constructor(private onLoadUnload:Subject<RuntimeLoadModuleTrigger>) {
		super();
	}

	protected override onSuccess() {
		if(!this._isTriggered) {
			this._isTriggered = true;
			this.onLoadUnload.next(this);
		}
	}

	protected override onFailure() {
		if(this._isTriggered) {
			this._isTriggered = false;
			this.onLoadUnload.next(this);
		}
	}

	/** Has the trigger been triggered yet? This prevents the trigger from triggering multiple times */
	get isTriggered():boolean {
		return this._isTriggered;
	}

	/** The survey module that owns this trigger */
	get sourceId():string {
		return this.getPropertyValue("sourceId", undefined);
	}

	set sourceId(val:string) {
		this.setPropertyValue("sourceId", val);
	}
}
